import { toObjectMap } from "@@/utilities/dictionary";

const alfredItemTypes = ["PRODUCT", "OPTIONAL"] as const;
type AlfredItemType = typeof alfredItemTypes[number];
const alfredItemTypeMap = toObjectMap<AlfredItemType>([...alfredItemTypes]);

export { alfredItemTypes, alfredItemTypeMap };
export type { AlfredItemType };
